import i18n from '@/utils/i18n';
import React, { useMemo } from 'react';
import { HorizontalSelector } from '@/components/horizontal-selector';
import { StyleProp, ViewStyle } from 'react-native';
import { useTheme } from '@/contexts/theme-context';

export enum FilterOption {
  CreditRequests = 'CREDIT_REQUESTS',
  External = 'EXTERNAL',
  Pepper = 'PEPPER',
}

interface Props {
  containerStyle?: StyleProp<ViewStyle>;
  hasCreditRequests: boolean;
  hasExternalOrders: boolean;
  hasPepperOrders: boolean;
  onFilterSelect: (option: FilterOption) => void;
  selectedFilter: FilterOption;
}

const pepperOrdersLabel = i18n.t('app_web');
const externalOrdersLabel = i18n.t('other');
const creditRequestsLabel = i18n.t('credit_requests');
const labelToChannelMap = {
  [creditRequestsLabel]: FilterOption.CreditRequests,
  [externalOrdersLabel]: FilterOption.External,
  [pepperOrdersLabel]: FilterOption.Pepper,
};

const channelToLabelMap = {
  [FilterOption.CreditRequests]: creditRequestsLabel,
  [FilterOption.External]: externalOrdersLabel,
  [FilterOption.Pepper]: pepperOrdersLabel,
};

export const OrderHistoryFilters: React.FC<Props> = ({
  containerStyle,
  hasCreditRequests,
  hasExternalOrders,
  hasPepperOrders,
  onFilterSelect,
  selectedFilter,
}) => {
  const theme = useTheme();

  const selectorOptions = useMemo(() => {
    const selectorOptions = [];
    if (hasPepperOrders) {
      selectorOptions.push(pepperOrdersLabel);
    }
    if (hasExternalOrders) {
      selectorOptions.push(externalOrdersLabel);
    }
    if (hasCreditRequests) {
      selectorOptions.push(creditRequestsLabel);
    }
    return selectorOptions;
  }, [hasCreditRequests, hasExternalOrders, hasPepperOrders]);

  return (
    <HorizontalSelector<string>
      containerStyle={containerStyle}
      data={selectorOptions}
      keyExtractor={(orderChannel) => orderChannel}
      onItemPress={(selectedLabel) =>
        selectedLabel && onFilterSelect(labelToChannelMap[selectedLabel])
      }
      selectedItem={channelToLabelMap[selectedFilter]}
      style={{
        backgroundColor: theme.colors.transparent,
      }}
      testID="order-history-filter"
      trackingKey="order_channel_selector"
    />
  );
};
